export default {
  PWmodule: {
    banner: '简介',
    bannerP1: `
         在PWmat的基础功能上，我们针对用户的使用需求开发了一些顶层模块（MODULE）。
         这些MODULE中的一部分是与已有的优秀工具的接口，一部分是以PWmat的计算结果为基础得到实际需要的物理量，
         一部分则是为特定的计算需求而设计的计算流程。 这些MODULE涵盖了物质结构，基础性质，
         针对大体系的计算以及机器学习力场等，功能全面，操作方便，欢迎用户下载和使用。详情请见
    `,
    bannerP1_1: '说明文档',
    bannerP1_2: '，文档中附有所有MODULE的链接。',
    menu1: '物质结构',
    menu1_1: '结构搜索',
    menu1_2: '无序结构',
    menu1_3: '分子动力学数据处理',
    menu1_4: 'CIF 文件转换与结构处理',
    menu2: '电子结构及声子计算',
    menu2_1: '电子结构',
    menu2_2: '声子计算',
    menu3: '光、磁、力学和极化性质',
    menu3_1: '光学性质',
    menu3_2: '磁学性质',
    menu3_3: '力学性质',
    menu3_4: '极化性质',
    menu4: '缺陷性质',
    menu5: '电化学性质',
    menu6: '输运性质',
    menu7: '超快动力学过程',
    menu9: '电子束辐照分解',
    menu10: '大体系计算',
    menu11: '机器学习力场',
    menu12: '所有',
    tabletitle: '使用 PWmat Module',
    tableC1: '名称',
    tableC2: '简介',
    tabletxt1: '教程',
    tabletxt2: '文件下载',
    tabletxt3: '示例',
  },
}